export const INITIAL_TAGS = [
  { id: 'vip', name: 'VIP', color: 'bg-amber-100 text-amber-700', border: 'border-amber-200' },
  { id: 'urgente', name: 'Urgente', color: 'bg-rose-100 text-rose-700', border: 'border-rose-200' },
  { id: 'followup', name: 'Follow-up', color: 'bg-blue-100 text-blue-700', border: 'border-blue-200' },
];
